import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from './utils/Toast';
import Loader from './utils/Loader';
import Navbar from './utils/Navbr';
import './style/AdvancePublisher.css';
import { useNavigate } from 'react-router-dom';

const AdvancePublisher = () => {
    // --- State ---
    const [loading, setLoading] = useState(true);
    const [loader, setLoader] = useState(true);
    const [advanceList, setAdvanceList] = useState([]);
    const [tableFilter, setTableFilter] = useState('');
    const navigate = useNavigate();
    // Creation State
    const [createSearch, setCreateSearch] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [selectedPub, setSelectedPub] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);

    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    };

    // --- 1. Fetch Advance List ---
    const fetchAdvancePublishers = async () => {
        setLoading(true);
        const adminToken = getCookie('adminToken');
        try {
            const response = await axios.post('https://publisher.cashbolt.in.net/server/', {
                action: 'fetchAdvancePublishers',
                adminToken: adminToken || 'demo_token'
            });
            if (response.data.status === true) {
                setAdvanceList(response.data.data);
            }
        } catch (error) {

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const adminToken = getCookie('adminToken');

        const init = async () => {
            try {
                // ✅ 1. Admin Auth Check
                const authRes = await axios.post('https://publisher.cashbolt.in.net/server/', {
                    action: 'checkAuthAdmin',
                    adminToken
                });

                if (!authRes.data.status) {
                    toast.error(authRes.data.message || 'Admin session expired');
                    navigate('/cbMediaAdmin7/login');
                    return;
                }

                fetchAdvancePublishers();
            } catch (err) {
                toast.error('Admin auth check failed');
                navigate('/cbMediaAdmin7/login');
            } finally {
                setLoader(false);
            }
        };
        init();
    }, []);

    // --- 2. Search Suggestions (For Creation) ---
    const handleCreateSearchChange = async (e) => {
        const val = e.target.value;
        setCreateSearch(val);

        if (val.length < 1) { // Changed to 1 so typing 'a' works
            setSuggestions([]);
            setShowDropdown(false);
            return;
        }

        try {
            const response = await axios.post('https://publisher.cashbolt.in.net/server/', {
                action: 'searchPublishers',
                query: val,
                adminToken: getCookie('adminToken') || 'demo_token'
            });

            if (response.data.status === true && response.data.data.length > 0) {
                setSuggestions(response.data.data);
                setShowDropdown(true);
            } else {
                // Fallback for demo if API returns false/empty but we want to show UI logic
                throw new Error("No API Data");
            }
        } catch (error) {
        }
    };

    const selectPublisher = (pub) => {
        setSelectedPub(pub);
        setCreateSearch('');
        setSuggestions([]);
        setShowDropdown(false);
    };

    const removeSelectedTag = () => {
        setSelectedPub(null);
    };

    // --- 3. Make Advance Publisher (Submit) ---
    const handleMakeAdvance = async () => {
        if (!selectedPub) return toast.warning("Please select a publisher first");

        setIsSubmitting(true);
        try {
            const response = await axios.post('https://publisher.cashbolt.in.net/server/', {
                action: 'makeAdvancePublisher',
                publisher_id: selectedPub.id,
                adminToken: getCookie('adminToken') || 'demo_token'
            });

            if (response.data.status === true) {
                toast.success(response.data.message || "Publisher Upgraded!");
                setSelectedPub(null);
                fetchAdvancePublishers();
            } else {
                toast.error(response.data.message || "Failed to update");
            }
        } catch (error) {
            toast.error("Server Error");
        } finally {
            setIsSubmitting(false);
        }
    };

    // --- 4. Remove from Advance List ---
    const handleRemove = async (id) => {
        if (!window.confirm("Revoke Advance Status for this publisher?")) return;

        const adminToken = getCookie('adminToken');

        try {
            const res = await axios.post('https://publisher.cashbolt.in.net/server/', {
                action: 'removeAdvancePublisher',
                adminToken: adminToken || 'demo_token',
                publisher_id: id
            });

            if (res.data.status) {
                toast.success(res.data.message || "Status Revoked");
                setAdvanceList(prev => prev.filter(p => p.id !== id));
            } else {
                toast.error(res.data.message || "Failed to revoke");
            }

        } catch (e) {
            toast.error("Server Error");
        }
    };


    const filteredTableData = advanceList.filter(p =>
        p.name.toLowerCase().includes(tableFilter.toLowerCase()) ||
        p.id.toLowerCase().includes(tableFilter.toLowerCase())
    );
    if (loader) return <Loader />;
    return (
        <div className="ap-wrapper_ap">
            <Navbar role="Administrator" isAdmin={true} />

            <div className="bg-shape_ap shape-1_ap"></div>
            <div className="bg-shape_ap shape-2_ap"></div>

            <div className="ap-content_ap">

                <div className="ap-header_ap">
                    <h2>Advance <span className="highlight_ap">Publishers</span></h2>
                    <p>Grant special privileges and higher tiers to top partners</p>
                </div>

                {/* --- SECTION 1: CREATE ADVANCE PUBLISHER --- */}
                <div className="creation-card_ap">
                    <div className="card-header_ap">
                        <h3>Grant Advance Status</h3>
                    </div>
                    <div className="creation-body_ap">
                        <div className="input-group-wrapper_ap">
                            <label>Search Publisher</label>
                            <div className="smart-input-container_ap">

                                {selectedPub && (
                                    <div className="selected-tag_ap">
                                        <span>{selectedPub.name}</span>
                                        <button onClick={removeSelectedTag}>&times;</button>
                                    </div>
                                )}

                                {!selectedPub && (
                                    <input
                                        type="text"
                                        placeholder="Type Name or ID (e.g. Rahul)..."
                                        value={createSearch}
                                        onChange={handleCreateSearchChange}
                                        className="smart-input_ap"
                                        onFocus={() => { if (suggestions.length > 0) setShowDropdown(true) }}
                                        // Optional: onBlur delay to allow clicking items
                                        onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                                    />
                                )}

                                {/* Suggestions Dropdown - Conditional Rendering Fix */}
                                {showDropdown && suggestions.length > 0 && !selectedPub && (
                                    <div className="suggestions-dropdown_ap">
                                        {suggestions.map(pub => (
                                            <div key={pub.id} className="suggestion-item_ap" onMouseDown={() => selectPublisher(pub)}>
                                                <span className="sug-name_ap">{pub.name}</span>
                                                <span className="sug-id_ap">{pub.id}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        <button className="make-advance-btn_ap" onClick={handleMakeAdvance} disabled={isSubmitting}>
                            {isSubmitting ? 'PROCESSING...' : 'MAKE ADVANCE'}
                            <div className="wave_ap"></div>
                        </button>
                    </div>
                </div>

                {/* --- SECTION 2: LIST & FILTER --- */}
                <div className="table-section_ap">

                    <div className="table-controls_ap">
                        <h3>Current Advance List</h3>
                        <div className="table-search_ap">
                            <input
                                type="text"
                                placeholder="Filter list..."
                                value={tableFilter}
                                onChange={(e) => setTableFilter(e.target.value)}
                            />
                            <span className="search-icon_ap">🔍</span>
                        </div>
                    </div>

                    <div className="table-card_ap">
                        {loading ? <div className="table-loader_owr">
                            <div className="spinner_owr"></div>
                            <p>Fetching Publishers...</p>
                        </div> : (
                            <div className="table-scroll_ap">
                                <table className="ap-table_ap">
                                    <thead>
                                        <tr>
                                            <th>Pub ID</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th className="text-center_ap">Date Added</th>
                                            <th className="text-center_ap">Status</th>
                                            <th className="text-center_ap">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredTableData.length > 0 ? (
                                            filteredTableData.map(row => (
                                                <tr key={row.id} className="table-row_ap">
                                                    <td className="mono_ap">{row.id}</td>
                                                    <td className="font-bold_ap">{row.name}</td>
                                                    <td className="muted_ap">{row.email}</td>
                                                    <td className="text-center_ap">{row.date_added}</td>
                                                    <td className="text-center_ap">
                                                        <span className={`status-pill_ap ${row.status}`}>{row.status}</span>
                                                    </td>
                                                    <td className="text-center_ap">
                                                        <button
                                                            className="icon-btn-remove_ap"
                                                            title="Revoke Access"
                                                            onClick={() => handleRemove(row.id)}
                                                        >
                                                            ✕
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="no-data_ap">No advance publishers found.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AdvancePublisher;